module.exports = __webpack_public_path__ + "img/g_papratilov.117d49b2.jpg";